import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { EmptyGlobalSearch, GlobalSearch, getSearchLoading } from 'src/app/shop';
import { CloseSearch } from 'src/app/store';
import { IconComponent } from '../icon/icon.component';
import { AsyncPipe } from '@angular/common';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { ClarityService } from '../../service/clarity.service';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IconComponent, ReactiveFormsModule, AsyncPipe, FromDictionaryPipe],
})
export class SearchBarComponent implements OnInit, AfterViewInit, OnDestroy {
  private fb = inject(UntypedFormBuilder);
  private store = inject(Store);
  private router = inject(Router);
  private clarity = inject(ClarityService);

  @ViewChild('input') input?: ElementRef<HTMLInputElement>;
  searchForm!: UntypedFormGroup;

  hasValue: boolean = false;

  private _unsubscribe$ = new Subject<void>();

  searchResultsLoading$!: Observable<boolean>;

  ngOnInit(): void {
    this.searchResultsLoading$ = this.store.select(getSearchLoading);

    this.searchForm = this.fb.group({
      q: [],
    });

    this.searchForm.valueChanges.pipe(takeUntil(this._unsubscribe$)).subscribe(a => {
      this.onSearch(a?.q);
      this.hasValue = a.q.length;
    });

    this.clarity.setClarityTag('interaction_type', 'search');
  }

  ngAfterViewInit(): void {
    if (this.input) {
      this.input.nativeElement.focus();
    }
  }

  onSearch(q?: string) {
    const query = q || this.searchForm?.value?.q;
    if (query && query.length) {
      this.store.dispatch(GlobalSearch({ searchQuery: query }));
    } else {
      this.store.dispatch(EmptyGlobalSearch({ searchQuery: '' }));
    }
  }

  closeSearch() {
    this.store.dispatch(CloseSearch());
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  toOverview() {
    if (this.searchForm?.value?.q) {
      this.router.navigate(['/products', 'search'], { queryParams: { q: this.searchForm?.value?.q } });
    }
  }
}
